import './App.css';
import './css/Sidebar.css';
import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { routes } from './routes';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  // Public routes that don't require authentication
  const publicPaths = [
    '/',
    '/auth/login',
    '/auth/signup',
    '/auth/forgot-password',
    '/auth/verify-email',
    '/auth/verify-link',
    '/auth/reset-password/link'
  ];

  return (
    <Router>
      <Routes>
        {routes.map((route) => {
          const isPublicRoute = publicPaths.includes(route.path);
          
          if (route.children) {
            const RouteComponent = route.component;
            return (
              <Route 
                key={route.path} 
                path={route.path} 
                element={
                  <ProtectedRoute>
                    <RouteComponent>
                      <Routes>
                        {route.children.map((child) => {
                          const ChildComponent = child.component;
                          return (
                            <Route
                              key={child.path}
                              path={child.path}
                              element={<ChildComponent />}
                            />
                          );
                        })}
                      </Routes>
                    </RouteComponent>
                  </ProtectedRoute>
                }
              />
            );
          }
          
          const RouteComponent = route.component;
          return (
            <Route
              key={route.path}
              path={route.path}
              element={
                isPublicRoute ? (
                  <RouteComponent />
                ) : (
                  <ProtectedRoute>
                    <RouteComponent />
                  </ProtectedRoute>
                )
              }
            />
          );
        })}
      </Routes>
    </Router>  
  );
}

export default App;